import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const previewWidgetDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),
  };
};
